import React, { useCallback, useEffect } from 'react';
import Turnstile from '../../components/turnstile/turnstile';

// The JavaScript channel the manager mobile app registers on its WebView.
// The app depends on this exact name.
export const CHANNEL = 'TurnstileBridge';

// Only ever to the embedding WebView's own channel. Never window.parent,
// window.opener or window.postMessage: a site that frames this page must
// receive nothing. In an ordinary browser there is no channel and this is a
// no-op.
export const post = (message) => {
  const channel = window[CHANNEL];
  if (channel && typeof channel.postMessage === 'function') {
    channel.postMessage(JSON.stringify(message));
  }
};

// Spec 2026-10-01 manager app §5. A page with nothing on it but the Turnstile
// widget. The manager app loads it off-screen in a WebView, takes the token
// from the channel and sends it to User/Login as X-Turnstile-Token, the same
// header the login page sends. When Cloudflare wants the user to interact
// (the widget is in managed mode) the app is told and shows the WebView.
const TurnstileBridge = () => {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  const onToken = useCallback((token) => {
    post(token ? { type: 'token', token } : { type: 'expired' });
  }, []);
  const onInteractive = useCallback(() => {
    post({ type: 'interactive' });
  }, []);
  const onError = useCallback((code) => {
    post({ type: 'error', code: code === undefined || code === null ? '' : String(code) });
  }, []);

  // No site key is local development, where the API does not check Turnstile
  // either (Turnstile:Enabled). The app's flow stays the same: it gets a
  // token, an empty one.
  useEffect(() => {
    if (!siteKey) post({ type: 'token', token: '' });
  }, [siteKey]);

  // Linked from nowhere, and not for search engines.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#FFFFFF',
      }}
    >
      <Turnstile onToken={onToken} onInteractive={onInteractive} onError={onError} />
    </div>
  );
};

export default TurnstileBridge;
